import { Roles } from "@/services/enums/SettingEnum.ts";
import { ISettingStore } from "@/redux/setting-slice/Model.ts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserLoginInfo } from "@/services/login-service/entities/UserLoginEntity.ts";
import { TimezoneInfo } from "@/services/entities/SettingEntity.ts";
import { ETheme } from "@/DependenciesV9";

const initialState: ISettingStore = {
  theme: ETheme.Light,
  timeZone: null,
  userInfo: null,
  userRoles: null,
  workingTenant: "root"
};

export const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ETheme>) => {
      state.theme = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<UserLoginInfo>) => {
      state.userInfo = action.payload;
    },
    setTimeZone: (state, action: PayloadAction<TimezoneInfo>) => {
      state.timeZone = action.payload;
    },
    setUserRoles: (state, action: PayloadAction<{ [x: string]: Roles[] }>) => {
      state.userRoles = action.payload;
    },
    setWorkingTenant: (state, action: PayloadAction<string>) => {
      state.workingTenant = action.payload
    }
  }
});

export const { setTheme, setUserInfo, setTimeZone, setUserRoles, setWorkingTenant } = settingSlice.actions;
export default settingSlice.reducer;